import { render, staticRenderFns } from "./platIncomeAndExpendDetail.vue?vue&type=template&id=54e74504&scoped=true"
import script from "./platIncomeAndExpendDetail.vue?vue&type=script&lang=js"
export * from "./platIncomeAndExpendDetail.vue?vue&type=script&lang=js"
import style0 from "./platIncomeAndExpendDetail.vue?vue&type=style&index=0&id=54e74504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e74504",
  null
  
)

export default component.exports